<template>
	<div class="watch-readings-details-widget widget-measure">
		<div class="header">
			<h2>{{ $t('readings.general.measure') }}</h2>
		</div>
		<div class="body">
			<h1>{{ readingType }}</h1>
			<spinner v-if="loading" class="spinner"/>
			<div v-else-if="reading" class="widget-measure-wrapper">
				<measure-heart-rate       v-if="isType(1)" v-model="reading"/>
				<measure-blood-pressure   v-if="isType(2)" v-model="reading"/>
				<measure-temperature      v-if="isType(3)" v-model="reading"/>
				<measure-blood-saturation v-if="isType(4)" v-model="reading"/>
				<measure-position         v-if="isType(5)" v-model="reading"/>
				<measure-calories         v-if="isType(6)" v-model="reading"/>
				<measure-pedometer        v-if="isType(7)" v-model="reading"/>
				<measure-falls            v-if="isType(8)" v-model="reading"/>
			</div>
			<div v-else class="no-results">{{ $t('readings.general.no_readings') }}</div>
		</div>
		<button @click="refresh" class="btn btn-icon btn-refresh">&nbsp;</button>
	</div>
</template>

<script>
import uniqueid from '@/utils/uniqueid'
import Readings from '@/utils/readings'
import Reading from '@/classes/Reading'
import MeasureHeartRate from '../../biometric/widgets/measure/MeasureHeartRate'
import MeasureBloodPressure from '../../biometric/widgets/measure/MeasureBloodPressure'
import MeasureTemperature from '../../biometric/widgets/measure/MeasureTemperature'
import MeasureBloodSaturation from '../../biometric/widgets/measure/MeasureBloodSaturation'
import MeasurePosition from '../../geofencing/widgets/measure/MeasurePosition'
import MeasureCalories from '../../biometric/widgets/measure/MeasureCalories'
import MeasurePedometer from '../../biometric/widgets/measure/MeasurePedometer'
import MeasureFalls from '../../biometric/widgets/measure/MeasureFalls'
export default {
	components: {
		MeasureHeartRate,
		MeasureBloodPressure,
		MeasureTemperature,
		MeasureBloodSaturation,
		MeasurePosition,
		MeasureCalories,
		MeasurePedometer,
		MeasureFalls
	},
	props: [
		'user_uid',
		'watch_id',
		'type_id',
		'refresh'
	],
	data () {
		return {
			name: 'watch biometric measure',
			loadingSet: new Set(),
			loadingTracker: 1,
			reading: null,
			offset: 0,
			limit: 1
		}
	},
	computed: {
		readingType () {
			return Readings.readingTypes.get(parseInt(this.type_id)).name
		},
		loading () {
			let temp = this.loadingTracker // Hack, force Vue computing loading
			return this.loadingSet.size > 0
		}
	},
	methods: {
		isType (type) {
			return this.type_id == type
		},
		getLastReading () {
			const uid = uniqueid()
			this.loadingSet.add(uid)
			this.loadingTracker++ // Hack, force Vue computing loading
			this.reading = null
			this.$api.readings.getAllByType(this, this.user_uid, this.watch_id, this.type_id, this.offset, this.limit)
				.then(response => {
					this.$log.info(this.name, 'readings.getAllByType OK', response)()
					if (response.body.length) {
						this.reading = new Reading(response.body[0])
					}
				}).catch(error => {
					this.$log.error(this.name, 'readings.getAllByType ERROR', error)()
				}).finally(() => {
					this.loadingSet.delete(uid)
					this.loadingTracker++ // Hack, force Vue computing loading
				})
		},
		onRouteChanged () {
			// Next tick, otherwise type_id is not correct
			this.$nextTick(function () {
				this.getLastReading()
			})
		}
	},
	created () {
		this.$parent.$on('biometric-details-route-changed', this.onRouteChanged)
		this.$parent.$on('biometric-details-refresh-readings', this.onRouteChanged)
	},
	beforeDestroy () {
		this.$parent.$off('biometric-details-route-changed', this.onRouteChanged)
		this.$parent.$off('biometric-details-refresh-readings', this.onRouteChanged)
	},
	mounted () {
		this.getLastReading()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/ReadingsWidgetMeasure.vue